import SelfReadingDTO from 'features/contracts/dtos/SelfReadingDTO';
import Card from 'features/shared/components/card/Card';
import PageCard from 'features/shared/components/card/PageCard';
import InfoItem from 'features/shared/components/infoItem/InfoItem';
import { formatDate, formatNumber } from 'features/shared/helpers/Formatters';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  selfReading: SelfReadingDTO;
  renderUnit?: () => JSX.Element;
}

const SelfReadingInfoCard = ({ selfReading, renderUnit }: Props) => {
  // translations
  const tLabels = useTranslation("contracts\\contracts").t;
  const tTypes = useTranslation("contracts\\enums\\selfReadingType").t;
  const tStatuses = useTranslation("contracts\\enums\\selfReadingStatus").t;

  // sub-renders
  const renderValue = (value: number) => {
    return (
      <>
        {formatNumber(value)} {renderUnit !== undefined && renderUnit()}
      </>
    );
  }

  // render
  return (
    <PageCard title={tLabels("selfReadingInfoCard.cardTitle")} bodyClassName="pb-0">
      <div className="row no-gutters">
        <div className="col-sm-6 col-lg-4 px-sm-3 pb-2 pb-sm-3">
          <InfoItem title={tLabels("selfReadingInfoCard.createdDate")} value={formatDate(selfReading.createdDate!)} icon="calendar-alt" />
        </div>
        <div className="col-sm-6 col-lg-4 px-sm-3 pb-2 pb-sm-3">
          <InfoItem title={tLabels("selfReadingInfoCard.readingDate")} value={formatDate(selfReading.readingDate!)} icon="calendar-check"  />
        </div>
        <div className="col-sm-6 col-lg-4 px-sm-3 pb-2 pb-sm-3">
          <InfoItem title={tLabels("selfReadingInfoCard.selfReadingStatus")} value={tStatuses(selfReading.selfReadingStatus!)} icon="tag" />
        </div>
        <div className="col-sm-6 col-lg-4 px-sm-3 pb-2 pb-sm-3">
          <InfoItem title={tLabels("selfReadingInfoCard.selfReadingType")} value={tTypes(selfReading.selfReadingType!)} icon="ticket-alt" />
        </div>
        <div className="col-sm-6 col-lg-4 px-sm-3 pb-2 pb-sm-3">
          <InfoItem title={selfReading.valueNT != null ? tLabels("selfReadingInfoCard.valueVT") : tLabels("selfReadingInfoCard.state")} value={renderValue(selfReading.value!)} icon="list-alt" />
        </div>
        {selfReading.valueNT != null &&
          <div className="col-sm-6 col-lg-4 px-sm-3 pb-2 pb-sm-3">
            <InfoItem title={tLabels("selfReadingInfoCard.valueNT")} value={renderValue(selfReading.valueNT!)} icon="list-alt"  />
          </div>
        }
        <div className="col-sm-6 col-lg-4 px-sm-3 pb-2 pb-sm-3">
          <InfoItem title={tLabels("selfReadingInfoCard.meterNumber")} value={selfReading.meterId ? selfReading.meterId : "-"} icon="tachometer-alt" />
        </div>
        {selfReading.rejectionReason != null &&
          <div className="col-sm-6 col-lg-4 px-sm-3 pb-2 pb-sm-3">
            <InfoItem title={tLabels("selfReadingInfoCard.rejectionReason")} value={selfReading.rejectionReason} icon="ban"  />
          </div>
        }
      </div>
    </PageCard>
  )
}

export default SelfReadingInfoCard;
